let locationsData = [
 {
  shopId: 'gainz',
  id: 'gainz',
  instagram: "sushi_.yu",
  basePath: "/winnetka", 
  cssGlobalPrefix: 'pablitoschicken dark-mode',
  mapLogo: 'https://afag.imgix.net/sushi-don/icon.png?w=250&auto=format',
  // disabled: true, openingDate: "visit/call to order",
  label: "Valley Village",
  className: 'night',
  address: ["4816 Laurel Canyon Blvd", "Valley Village, CA 91607"],
  phone: "(818) 843-3433",
  phoneLink: "+18188433433",
  orderLink: "/winnetka/order",
  lat: 34.0944399, lng:-118.128288,
  storefrontPhoto: "https://afag.imgix.net/sushi-don/store.png?w=600&auto=format",
  hours: [
    { day: 'Mon-Sat', hours: '11:30am-3pm 4pm-8:30pm' },
    { day: 'Sunday', hours: '11:30am-3pm 4pm-7:30pm' },
  ]},
];

const siteData = {
  siteLogo: "https://afag.imgix.net/pufflava/logo-bar.png?w=500&auto=format",
  domain: "yeranspufflava.com",
  name: "Yeran's Pufflava | Armenian & Vegan Baklava in Los Angeles",
  shortName: "Pufflava",
  description:
    "Handmade in Los Angeles, Yeran’s Pufflavas are Patil V’s vegan, pistachio-filled Armenian baklava puffs — perfectly round, airy, flaky, and irresistibly nostalgic.",
  folderId: "pufflava",
  ogImage: "https://afag.imgix.net/pufflava/logo.jpg?w=1000&auto=format",
  iconRoot: "https://afag.imgix.net/pufflava/logo-bar.png?w=500&auto=format",
};

export { siteData };
export default locationsData;

